// Keep enabled for the maintenance deployment; set to false when writes can resume.
export const maintenance = { enabled: true };
